import { load } from "./index.js"
(function () {
  load()
})()
